import * as React from 'react';
import Content from './Content';

export default class ContentContainer extends React.Component {
    render() {
        return <Content></Content>
    }
}